import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { useQuery } from '@tanstack/react-query';
import { createFileRoute } from '@tanstack/react-router';

import { teamPlanSummaryQueryOptions } from '@/routes/researchers/_authenticated/projects/$projectId/-launch/team-pricing-version';

import { BalanceActivity } from './-balance-activity';

export const Route = createFileRoute(
  '/researchers/_authenticated/billing/activity',
)({
  component: BillingActivityPage,
  head: () => ({ meta: [{ title: t`Activity` }] }),
});

function BillingActivityPage() {
  const { user, activeDashboard } = Route.useRouteContext();
  const teamId = activeDashboard.team ?? '';
  const {
    data: summary,
    isPending,
    isError,
  } = useQuery({
    ...teamPlanSummaryQueryOptions(teamId, user.id),
    enabled: !!teamId,
  });

  return (
    <>
      {!summary?.plan && (
        <h1 className="text-display-xs font-semibold text-primary">
          <Trans>Activity</Trans>
        </h1>
      )}
      {isPending && (
        <p role="status" className="text-sm text-secondary">
          <Trans>Loading activity…</Trans>
        </p>
      )}
      {isError && (
        <p role="alert" className="text-sm text-error-primary">
          <Trans>Could not load balance activity.</Trans>
        </p>
      )}
      {!isPending && !isError && !summary?.plan && (
        <p role="status" className="text-sm text-secondary">
          <Trans>No pricing plan is available for this team.</Trans>
        </p>
      )}
      {teamId && summary?.plan && (
        <BalanceActivity
          teamId={teamId}
          userId={user.id}
          pricingVersion={summary.plan.pricingVersion}
        />
      )}
    </>
  );
}
